module.exports = __webpack_public_path__ + "img/OverseaMember55.3140a3ba.jpg";